const setAccountId = (accountId) => {
	return {
		type: 'SET_ACCOUNT_ID',
		accountId: accountId,
	};
};

const setMediaName = (mediaName) => {
	return {
		type: 'SET_MEDIA_NAME',
		mediaName: mediaName,
	};
};

const setScreenType = (screenType) => {
	return {
		type: 'SET_SCREEN_TYPE',
		screenType: screenType,
	};
};

const setPollExpanded = (isPollExpanded) => {
	return {
		type: 'SET_POLL_EXPANDED',
		isPollExpanded: isPollExpanded,
	};
};

const setMediaType = (mediaType) => {
	return {
		type: 'SET_MEDIA_TYPE',
		mediaType: mediaType,
	};
};

const setScenarioThumbnail = (thumbnailUrl) => {
	return {
		type: 'SET_SCENARIO_THUMBNAIL',
		thumbnailUrl: thumbnailUrl,
	};
};

const setSceneConfig = (sceneConfig) => {
	return {
		type: 'SET_SCENE_CONFIG',
		sceneConfig: sceneConfig,
	};
};

const setScenario = (scenario) => {
	return {
		type: 'SET_SCENARIO',
		scenario: scenario,
	};
};

const setVideoDownloadUrl = (videoDownloadUrl) => {
	return {
		type: 'SET_VIDEO_DOWNLOAD_URL',
		videoDownloadUrl: videoDownloadUrl,
	};
};

const setVideoHoverUrl = (videoHoverUrl) => {
	return {
		type: 'SET_VIDEO_HOVER_URL',
		videoHoverUrl: videoHoverUrl,
	};
};

const setCurrentMediaId = (currentMediaId) => {
	return {
		type: 'SET_CURRENT_MEDIA_ID',
		currentMediaId: currentMediaId,
	};
};
const setCurrentPlaylistId = (playlistId) => {
	return {
		type: 'SET_PLAYLIST_ID',
		playlistId: playlistId,
	};
};

const setRelatedMediaOfScene = (relatedMediasOfScene) => {
	return {
		type: 'SET_RELATED_MEDIAS_OF_SCENE',
		relatedMediasOfScene: relatedMediasOfScene,
	};
};
const setPlaylistData = (playlistData) => {
	return {
		type: 'SET_PLAYLIST_DATA',
		playlistData: playlistData,
	};
};

const setMediasData = (mediasData) => {
	return {
		type: 'SET_MEDIAS_DATA',
		mediasData: mediasData,
	};
};

const setGetDataIndividually = (shouldGetDataIndividually) => {
	return {
		type: 'SET_SHOULD_GET_DATA_INDIVIDUALLY',
		shouldGetDataIndividually: shouldGetDataIndividually,
	};
};

const setCurrentConfigId = (currentConfigId) => {
	return {
		type: 'SET_CURRENT_CONFIG_ID',
		currentConfigId: currentConfigId,
	};
};

const setIsMediaLive = (isMediaLive) => {
	return {
		type: 'SET_IS_MEDIA_LIVE',
		isMediaLive: isMediaLive,
	};
};

const setChapters = (chapters) => {
	return {
		type: 'SET_MEDIA_CHAPTERS',
		chapters: chapters,
	};
};

const setReactionUrl = (reactionUrl) => {
	return {
		type: 'SET_REACTION_URL',
		reactionUrl: reactionUrl,
	};
};

const setRestrictedToken = (restrictedToken) => {
	return {
		type: 'SET_RESTRICTED_TOKEN',
		restrictedToken: restrictedToken,
	};
};

const setIsMaintainProportions = (isMaintainProportions) => {
	return {
		type: 'MAINTAIN_PROPORTIONS',
		isMaintainProportions: isMaintainProportions,
	};
};

const setOpenSharingModal = (openSharingModal) => {
	return {
		type: 'SET_OPEN_SHARING_MODAL',
		openSharingModal: openSharingModal,
	};
};

const setShowCountdownModule = (showCountdownModule) => {
	return {
		type: 'SET_SHOWN_COUNTDOWN',
		showCountdownModule: showCountdownModule,
	};
};

const setOpenSettingMenu = (openSettingMenu) => {
	return {
		type: 'SET_OPEN_SETTING_MENU',
		openSettingMenu: openSettingMenu,
	};
};

const setShouldChangeCurrentMedia = (shouldChangeCurrentMedia) => {
	return {
		type: 'SHOULD_RESET_CURRENT_MEDIA',
		shouldChangeCurrentMedia: shouldChangeCurrentMedia,
	};
};

const setChangeSceneType = (changeSceneType) => {
	return {
		type: 'SET_CHANGE_SCENE_TYPE',
		changeSceneType: changeSceneType,
	};
};

const setViewerEngagementModuleActivated = (viewerEngagementModuleActivated) => {
	return {
		type: 'SET_VIEWER_ENGAGEMENT_MODULE_ACTIVATED',
		viewerEngagementModuleActivated: viewerEngagementModuleActivated,
	};
};

const setChatActivated = (isChatActivated) => {
	return {
		type: 'SET_CHAT_ACTIVATED',
		isChatActivated: isChatActivated,
	};
};

const setCloseIncomingMessage = (isCloseIncomingMessage) => {
	return {
		type: 'SET_CHAT_CLOSE_INCOMING_MESSAGE',
		isCloseIncomingMessage: isCloseIncomingMessage,
	};
};

const updateSceneHistory = (newPath) => {
	return {
		type: 'UPDATE_SCENE_HISTORY',
		newPath: newPath,
	};
};

const setSceneHistory = (scenePath) => {
	return {
		type: 'SET_SCENE_HISTORY',
		scenePath: scenePath,
	};
};

const setTransitionLayer = (isActive) => {
	return {
		type: 'SET_TRANSITION_LAYER',
		isActive,
	};
};

const setTransitionOut = (transitionType) => {
	return {
		type: 'SET_TRANSITION_OUT_TYPE',
		transitionType,
	};
};

const setTransitionEffectStatus = (isActive) => {
	return {
		type: 'SET_TRANSITION_EFFECT_STATUS',
		isActive,
	};
};

const setEmbedShareSettings = (embedShareSettings) => {
	return {
		type: 'SET_EMBED_SHARE_SETTINGS',
		embedShareSettings,
	};
};

const setRestrictedMedias = (restrictedMedias) => {
	return {
		type: 'SET_RESTRICTED_MEDIAS',
		restrictedMedias: restrictedMedias,
	};
}

const setTranscriptions = (transcriptions) => {
	return {
		type: 'SET_TRANSCRIPTIONS',
		transcriptions: transcriptions,
	};
}

const setShowTranscriptionsModule = (showTranscriptionsModule) => {
	return {
		type: 'SET_SHOW_TRANSCRIPTIONS_MODULE',
		showTranscriptionsModule: showTranscriptionsModule,
	};
}

const setSubtitleLanguage = (subtitleLanguage) => {
	return {
		type: 'SET_SUBTITLE_LANGUAGE',
		subtitleLanguage: subtitleLanguage,
	};
}

const setMinimizedPlayerState = (minimizedPlayer) => {
	return {
		type: 'SET_MINIMIZE_PLAYER_STATE',
		minimizedPlayer: minimizedPlayer,
	};
}

export {
	setSubtitleLanguage,
	setShowTranscriptionsModule,
	setTranscriptions,
	setCloseIncomingMessage,
	setPlaylistData,
	setRestrictedMedias,
	setEmbedShareSettings,
	setShowCountdownModule,
	setSceneHistory,
	updateSceneHistory,
	setChatActivated,
	setViewerEngagementModuleActivated,
	setChangeSceneType,
	setShouldChangeCurrentMedia,
	setOpenSharingModal,
	setOpenSettingMenu,
	setIsMaintainProportions,
	setAccountId,
	setReactionUrl,
	setCurrentMediaId,
	setCurrentConfigId,
	setMediaName,
	setIsMediaLive,
	setVideoDownloadUrl,
	setVideoHoverUrl,
	setMediaType,
	setSceneConfig,
	setScenario,
	setMediasData,
	setScreenType,
	setGetDataIndividually,
	setPollExpanded,
	setChapters,
	setRestrictedToken,
	setScenarioThumbnail,
	setRelatedMediaOfScene,
	setCurrentPlaylistId,
	setTransitionLayer,
	setTransitionOut,
	setTransitionEffectStatus,
	setMinimizedPlayerState
};
